import styled from 'styled-components'

export const OverlayVerMalha = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const ContainerVerMalhaModal = styled.div`
  background-color: #fff;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  position: relative;
`

export const WrapperMapaVerMalha = styled.div`
  flex: 1;
  width: 100%;
  height: 100%;
  position: relative;
`

export const CardFlutuanteInfo = styled.div`
  position: absolute;
  width: 400px;
  top: 15px;
  left: 15px;
  background-color: white;
  padding: 15px;
  border-radius: 10px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
  gap: 15px;
  z-index: 10;

  .container__info__malha {
    width: 100%;
    display: flex;
    gap: 15px;
    justify-content: space-between;
  }

  .info__item {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    label {
      font-size: 11px;
      font-weight: 500;
      color: #7b7b7b;
      padding: 0;
      margin: 0;
      white-space: nowrap;
    }

    p {
      padding: 0;
      margin: 0;
      line-height: 1.2;
      font-size: 13px;
      font-weight: 600;
    }
  }
`